import { Box, TextField, Button, Typography } from "@mui/material";
import * as yup from "yup";
import { Formik } from "formik";
import SnackbarComponent from "components/SnackbarComponent";
import { sendPasswordResetEmail } from "reduxStore/actions/authActions";
import { useDispatch } from "react-redux";
import { setSnackbar } from "reduxStore/state";

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email("invalid email").required("required"),
});

function ForgotPasswordForm({ handleBackToLogin }) {
  const dispatch = useDispatch();

  const handleForgotPassword = async (values) => {
    try {
      // Dispatch the action to send the password reset email
      const response = await dispatch(sendPasswordResetEmail(values.email));
      // Handle success and failure appropriately
      if (response) {
        dispatch(
          setSnackbar({
            open: true,
            message: "Password reset link sent. Check your inbox.",
            severity: "success",
          })
        );
      } else {
        dispatch(
          setSnackbar({
            open: true,
            message: "Failed to send reset link.",
            severity: "error",
          })
        );
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          open: true,
          message: "An error occurred. Please try again.",
          severity: "error",
        })
      );
    }
  };

  return (
    <Box>
      <Formik
        initialValues={{ email: "" }}
        validationSchema={forgotPasswordSchema}
        onSubmit={handleForgotPassword}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <TextField
                label="Email"
                name="email"
                value={values.email}
                onChange={handleChange}
                error={errors.email && touched.email}
                helperText={errors.email && touched.email && errors.email}
                variant="outlined"
                margin="normal"
                sx={{ width: "100%" }}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                sx={{ mt: "1rem", width: "100%" }}
              >
                Send Reset Link
              </Button>
              <Typography
                sx={{ mt: "1rem", cursor: "pointer" }}
                onClick={handleBackToLogin}
              >
                Back to Login
              </Typography>
            </Box>
          </form>
        )}
      </Formik>
      <SnackbarComponent />
    </Box>
  );
}

export default ForgotPasswordForm;
